// modules
import React, { useEffect, useState } from 'react'
import { usePanelHistoryTop } from 'weblite-router'
// logic
import { getModalPool } from '../logic/pool'
import { modalQueue } from '../logic/queue'

export let closeModalComponent = null

export function ModalRenderer({ cid }) {
  const [isOpen, setIsOpen] = useState(false)
  useEffect(() => {
    closeModalComponent = () => setIsOpen(false)
    setIsOpen(true)

    return () => {
      closeModalComponent = null
    }
  }, [])

  const { Component, props: coldProps } = getModalPool()[cid]
  const { props: hotProps = {} } = modalQueue.head() || {}

  return <Component {...coldProps} {...hotProps} isOpen={isOpen} />
}
